// extracted by mini-css-extract-plugin
module.exports = {"trackerSwitch":"oy052"};